<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="fm2"> </p>
<p class="linespace"> </p>
<p class="tni">Forlorn hope … 1: In early use, a picked body of men, detached to the front to begin the attack.…</p>
<p class="tni">b. <span class="epub-i">transf.</span> and <span class="epub-i">fig,</span> chiefly of persons in a desperate condition.</p>
<p class="tni">c. <span class="epub-i">pl.</span> The men comprising such a body; hence, reckless bravos.</p>
<p class="tni">d. A perilous or desperate enterprise.…</p>
<p class="tni">OXFORD ENGLISH DICTIONARY</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm1.vue?76aa6482